var image_upload_default = {
  "container": "m0sxt",
  "disabled": "IiJj5",
  "imageInput": "oheLM",
  "overlay": "_2MU-a",
  "text": "hrIQs",
  "shown": "-WIPt",
  "hide": "V04eg",
  "spinner": "s-uO7",
  "spin": "u2PKT"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
